import { render } from "./BrowsePetsPage.vue?vue&type=template&id=bb273874&scoped=true"
import script from "./BrowsePetsPage.vue?vue&type=script&lang=js"
export * from "./BrowsePetsPage.vue?vue&type=script&lang=js"

import "./BrowsePetsPage.vue?vue&type=style&index=0&id=bb273874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb273874"]])

export default __exports__